// import _ from 'lodash'
import api from '../../api/index'
import * as types from '../../types/index'

// 企业那边接口有改动的话，修改请求和对应参数即可
export default {
  state: {
    realNameState: -1,
    realNameAuth: {},
    mobile: '',
    name: '',
    idno: '',
    cardno: '',
    proNumber: '',
    SMSCode: '',
    isAuth: '',
    bankList: [],
    bankType: '借记卡',
    bankRegion: [],
    bankName: '',
    bankNameValue: '',
    bankBranchName: '',
    bankAccountId: '',
    bankAccountName: '',
    hasReadContract: false
  },
  getters: {
    [types.GET_REAL_NAME_AUTH_ALL_INFO] (state) {
      return {
        mobile: state.mobile,
        name: state.name,
        idno: state.idno,
        cardno: state.cardno,
        proNumber: state.proNumber,
        SMSCode: state.SMSCode,
        bankList: state.bankList,
        isAuth: state.isAuth,
        bankType: state.bankType,
        bankRegion: state.bankRegion,
        bankName: state.bankName,
        bankNameValue: state.bankNameValue,
        bankBranchName: state.bankBranchName,
        bankAccountId: state.bankAccountId,
        bankAccountName: state.bankAccountName,
        hasReadContract: state.hasReadContract
      }
    },
    [types.GET_BANK_LIST]: state => state.bankList,
    [types.GET_REAL_NAME_STATE]: state => state.realNameState
  },
  actions: {
    [types.GET_REAL_NAME_AUTH_DATA] ({dispatch, commit}, params) {
      if(Number(params.crmCustomerType) === 1){
    	  return api.authPersonInfo({token: params.token})
      }else if(Number(params.crmCustomerType) === 2){
    	  return api.getEnterpriseAuthInfo({token: params.token})
      }
    }
  },
  mutations: {
    [types.SET_REAL_NAME_AUTH_ALL_INFO] (state, data) {
      state.mobile = data.BankAuthApply.mobile ? data.BankAuthApply.mobile : ''
      state.name = data.BankAuthApply.name
      state.idno = data.BankAuthApply.idno
      state.cardno = data.BankAuthApply.cardno ? data.BankAuthApply.cardno : ''
      state.bankType = '借记卡'
      state.bankRegion = data.bankList.length && data.bankList[0].bankCounty ? [data.bankList[0].bankProvince, data.bankList[0].bankCity, data.bankList[0].bankCounty] : []
      state.bankName = data.bankList.length && data.bankList[0].bankName ? data.bankList[0].bankName : ''
      state.bankNameValue = data.bankNameValue ? data.bankNameValue : ''
      state.bankBranchName = data.bankList.length && data.bankList[0].bankBranchName ? data.bankList[0].bankBranchName : ''
      state.bankAccountId = data.bankList.length && data.bankList[0].bankAccountId ? data.bankList[0].bankAccountId : ''
      state.bankAccountName = data.bankList.length && data.bankList[0].bankAccountName ? data.bankList[0].bankAccountName : ''
      state.hasReadContract = false
    },
    [types.SET_BANK_LIST] (state, data) {
      state.bankList = data
    },
    [types.UPDATE_BANK_CARD_NUM] (state, data) {
      state.cardno = data
    },
    [types.SET_REAL_NAME_STATE] (state, data) {
      state.realNameState = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/personalCenter/realNameAuth.js